import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Purchase — per-location supplier purchasing. Liquor purchases stock in.
const locBase = (restaurantId, locationId) =>
  `${API_URL}/users/restaurant/${restaurantId}/locations/${locationId}`;

const qs = (params = {}) => {
  const s = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''),
  ).toString();
  return s ? `?${s}` : '';
};

// List this location's purchases (head + line count + total).
export const listPurchases = async (restaurantId, locationId) => {
  const { data } = await axios.get(`${locBase(restaurantId, locationId)}/purchases/`);
  return data?.results || [];
};

// One purchase with its lines.
export const getPurchase = async (restaurantId, locationId, purchaseId) => {
  const { data } = await axios.get(`${locBase(restaurantId, locationId)}/purchases/${purchaseId}/`);
  return data?.data || null;
};

// The purchase payload: an invoice header plus lines of dish, variant, quantity and unit cost.
export const createPurchase = async (restaurantId, locationId, payload) => {
  const { data } = await axios.post(`${locBase(restaurantId, locationId)}/purchases/`, payload);
  return data?.data;
};

// Search liquor products for the line picker. params: { q }
export const searchLiquorProducts = async (restaurantId, locationId, params = {}) => {
  const { data } = await axios.get(
    `${locBase(restaurantId, locationId)}/purchase-liquor-products/${qs(params)}`,
  );
  return data?.results || [];
};
